import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton, Typography } from "@mui/material";
import { useCandidateRejectionReasons } from "../../../common/components/functional/candidateRejection/useCandidateRejectionReasons";
import { useTranslation } from "react-i18next";
import InfoTooltip from "../../../common/components/functional/InfoTooltip/InfoTooltip";
import {
  TalentIntroduction,
  TalentIntroducedToCustomerStatus,
} from "../../talents/types/queries";

type Props = Pick<
  TalentIntroduction,
  "status" | "rejectionReason" | "rejectionComment"
>;

export const IntroductionStatus = ({
  status,
  rejectionReason,
  rejectionComment,
}: Props) => {
  const { t } = useTranslation();
  const labels = useCandidateRejectionReasons();
  const isRejected =
    status === TalentIntroducedToCustomerStatus.Rejected ||
    status === TalentIntroducedToCustomerStatus.EezyRejected;

  return (
    <Box>
      <Typography variant="body2">
        {t(`talentProfile:introductions.statuses.${status}`)}
      </Typography>
      {isRejected && (rejectionReason || rejectionComment) && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            {labels[rejectionReason || "OtherReason"]}
          </Typography>
          {rejectionComment && (
            <InfoTooltip
              title={rejectionComment}
              slotProps={{
                tooltip: {
                  sx: {
                    whiteSpace: "pre-wrap",
                    overflowWrap: "anywhere",
                    maxWidth: 400,
                  },
                },
              }}
              icon={
                <IconButton
                  size="small"
                  aria-label={t("common:rejectionReason")}
                  onClick={(event) => event.stopPropagation()}
                  sx={{ p: 0, flexShrink: 0 }}
                >
                  <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                </IconButton>
              }
            />
          )}
        </Box>
      )}
    </Box>
  );
};
